import SearchQuote from './SearchQuote'

export default SearchQuote
